import React from 'react'
import AddPatientMenu from '../AddPatientMenu'
import {
  SlidingBarContainer,
  ScrollContainer,
  StyledAverage,
  StyledChip,
  StyledEmptyWaitingRoom,
  StyledMinimizeButton,
  StyledPaper,
  StyledTitle,
  StyledTitleBox,
  StyledArrowLeftIcon,
  StyledAccessTimeIcon,
  StyledLargeAddIcon,
  WaitingRoomHeader,
  CheckInButton,
} from './WaitingRoom.styles'
import { useWaitingRoomLogic } from './WaitingRoom.logic'
import PatientCard from '../PatientCard/PatientCard'
import { EPatientStatus, TRoomViewScheduledSurgery } from '../RoomView.types'
import { TWaitingRoomProps } from './WaitingRoom.types'

const WaitingRoom: React.FC<TWaitingRoomProps> = (props) => {
  const { isHidden, setIsHidden } = props
  const logic = useWaitingRoomLogic()

  return (
    <SlidingBarContainer $isHidden={isHidden}>
      <StyledPaper>
        <WaitingRoomHeader>
          <StyledTitleBox>
            <StyledTitle>Waiting Room</StyledTitle>
            {logic.waitingRoomPatients.length > 0 && (
              <StyledChip>{logic.waitingRoomPatients.length}</StyledChip>
            )}
            <StyledMinimizeButton onClick={() => setIsHidden(true)}>
              <StyledArrowLeftIcon />
            </StyledMinimizeButton>
          </StyledTitleBox>
          <StyledAverage>
            <StyledAccessTimeIcon />
            {`Avg waiting time: ${logic.getAverageWaitingTime()}`}
          </StyledAverage>

          <CheckInButton
            variant="contained"
            size="small"
            onClick={logic.handleAddButtonClick}
          >
            CHECK-IN PATIENT
          </CheckInButton>
        </WaitingRoomHeader>
        <ScrollContainer $isEmpty={logic.waitingRoomPatients.length === 0}>
          {logic.waitingRoomPatients.length > 0 ? (
            logic.waitingRoomPatients.map((waitingRoomPatient) => (
              <PatientCard
                key={waitingRoomPatient._id}
                surgery={
                  logic.scheduledSurgeries.find(
                    (surgery) => surgery.patient._id === waitingRoomPatient._id
                  ) as TRoomViewScheduledSurgery
                }
              />
            ))
          ) : (
            <StyledEmptyWaitingRoom onClick={logic.handleAddButtonClick}>
              <div>Click to add a patient</div>
              <StyledLargeAddIcon />
            </StyledEmptyWaitingRoom>
          )}
        </ScrollContainer>

        <AddPatientMenu
          anchorEl={logic.addButtonAnchorEl}
          onClose={logic.handleAddButtonClose}
          roomName="Waiting Room"
          status={EPatientStatus.CHECKED_IN}
        />
      </StyledPaper>
    </SlidingBarContainer>
  )
}

export default WaitingRoom
